import { DtMedia } from '@ow/ditto-core'

const { config } = DtMedia

export { default as Render } from './render'
export { config }
